import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({name: 'groupTerm'})
export class GroupTermPipe implements PipeTransform {

    transform(value: any) {
        switch(value) {
          case 'group': return 'team';
          case 'Group': return 'Team';
          case 'edition': return 'global';
          case 'Edition': return 'Global';
        }
        return value;
    }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/pipes/groupTerm.pipe.ts